/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */


document.addEventListener('click', function (event) {
  const isExpandButton =
    event.target.matches('.expand-button') ||
    event.target.closest('.expand-button') !== null;

  const expanderParent = event.target.closest('.expander');

  if (isExpandButton && expanderParent) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});

function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  let maxHeight = '999em';
  if (!expanderElement.classList.contains('expand')) {
    maxHeight = expanderElement.dataset.minimalHeight ?? '50px';
  }
  const contentElement = expanderElement.querySelector('.expander-content');
  if (contentElement) {
    contentElement.style.maxHeight = maxHeight;
  }
}

document.querySelectorAll('.expander').forEach(expander => {
  toggleExpander(expander, false);
});

/* ================================
   LANGUAGE SWITCHER – Definitieve versie met 2-letter codes
   Zet dit NA je HTML van de language switch en NA het laden van element.js
==================================*/

/* Configuratie */
const GT_CONFIG = {
  sourceLang: 'nl',                 // brontaal van je site
  defaultTargetLang: 'en',          // doeltaal voor eerste bezoek
  autoTranslateOnFirstVisit: false   // zet uit als je nooit auto EN wilt
};

/* Elements */
const btn  = document.getElementById('langBtn');
const menu = document.getElementById('langMenu');

/* Cookie helpers */
function setCookie(name, value, days, path = '/', domain) {
  const d = new Date();
  d.setTime(d.getTime() + days*24*60*60*1000);
  const expires = '; expires=' + d.toUTCString();
  const domainPart = domain ? '; domain=' + domain : '';
  document.cookie = name + '=' + value + expires + '; path=' + path + domainPart;
}
function deleteCookieEverywhere(name) {
  setCookie(name, '', -1, '/');
  const host = location.hostname.replace(/^www\./,'');
  if (host.includes('.')) setCookie(name, '', -1, '/', '.' + host);
}
function setCookieEverywhere(name, value, days) {
  setCookie(name, value, days, '/');
  const host = location.hostname.replace(/^www\./,'');
  if (host.includes('.')) setCookie(name, value, days, '/', '.' + host);
}
function getCookie(name) {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g,'\\$1') + '=([^;]*)'));
  return m ? decodeURIComponent(m[1]) : null;
}

/* Google Translate helpers */
function clearGTCookies() { deleteCookieEverywhere('googtrans'); }
function setGTCookiePath(from, to) { setCookieEverywhere('googtrans', `/${from}/${to}`, 365); }

/* Huidige taal uit cookie */
function getCurrentLangFromCookie() {
  const v = getCookie('googtrans');
  if (v && v.split('/')[2]) return v.split('/')[2];
  return GT_CONFIG.sourceLang;
}

/* Label knop zetten (altijd 2-letter code, of bijv. ZH-CN → ZH) */
function setButtonLabelByLang(lang) {
  if (!btn) return;
  const shortCode = lang.split('-')[0].toUpperCase();
  btn.textContent = shortCode + ' ˅';
}

/* Taal toepassen */
function applyLanguage(lang) {
  const select = document.querySelector('#google_translate_element select.goog-te-combo');

  if (lang === GT_CONFIG.sourceLang) {
    // Bewust terug naar brontaal
    sessionStorage.setItem('manualNLReset', '1');
    setCookieEverywhere('forceNL', 'true', 365);
    clearGTCookies();

    // Reset mogelijke Google state
    const frame = document.querySelector('iframe.goog-te-banner-frame');
    if (frame) frame.remove();

    location.reload();
    return;
  }

  // Naar een andere taal: forceNL wissen, cookie (en evt. select) zetten
  deleteCookieEverywhere('forceNL');

  if (select) {
    select.value = lang;
    select.dispatchEvent(new Event('change'));
  } else {
    setGTCookiePath(GT_CONFIG.sourceLang, lang);
    location.reload();
  }
}

/* Alleen dropdown functionaliteit als elementen bestaan */
if (btn && menu) {
  /* Dropdown open/dicht */
  btn.addEventListener('click', () => {
    const open = menu.hasAttribute('hidden') === false;
    if (open) {
      menu.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    } else {
      menu.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
  
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.lang-switch')) {
      menu.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    }
  });

  /* Klikken op custom menu */
  menu.addEventListener('click', (e) => {
    const li = e.target.closest('li[data-lang]');
    if (!li) return;
    const lang = li.getAttribute('data-lang');
    applyLanguage(lang);

    setButtonLabelByLang(lang);
    menu.setAttribute('hidden', '');
    btn.setAttribute('aria-expanded', 'false');
  });

  /* Init knoplabel bij laden */
  function initLabel() {
    const forceNL = getCookie('forceNL') === 'true';
    const lang = forceNL ? GT_CONFIG.sourceLang : getCurrentLangFromCookie();
    setButtonLabelByLang(lang);

    // fallback als select later inlaadt
    const select = document.querySelector('#google_translate_element select.goog-te-combo');
    if (!select) setTimeout(initLabel, 300);
  }
  initLabel();
}

/* Automatisch vertalen op eerste bezoek, afhankelijk van config */
(function autoTranslateFirstVisit() {
  if (!GT_CONFIG.autoTranslateOnFirstVisit) return;

  const desiredPath = `/${GT_CONFIG.sourceLang}/${GT_CONFIG.defaultTargetLang}`;
  const hasGoogTrans = !!getCookie('googtrans');
  const manualReset  = sessionStorage.getItem('manualNLReset') === '1';
  const forceNL      = getCookie('forceNL') === 'true';

  if (!hasGoogTrans && !manualReset && !forceNL) {
    setCookieEverywhere('googtrans', desiredPath, 365);
  } else if (manualReset) {
    sessionStorage.removeItem('manualNLReset');
  }
})();



/*! iFrame Resizer (iframeSizer.contentWindow.min.js) - v4.3.9 - 2023-11-10
 *  Desc: Include this file in any page being loaded into an iframe
 *        to force the iframe to resize to the content size.
 *  Requires: iframeResizer.min.js on host page.
 *  Copyright: (c) 2023 David J. Bradshaw - dave@bradshaw.net
 *  License: MIT
 */
!function(a){if("undefined"!=typeof window){var r=!0,P="",u=0,c="",s=null,D="",d=!1,j={resize:1,click:1},l=128,q=!0,f=1,n="bodyOffset",m=n,H=!0,W="",h={},g=32,B=null,p=!1,v=!1,y="[iFrameSizer]",J=y.length,w="",U={max:1,min:1,bodyScroll:1,documentElementScroll:1},b="child",V=!0,X=window.parent,T="*",E=0,i=!1,Y=null,O=16,S=1,K="scroll",M=K,Q=window,G=function(){x("onMessage function not defined")},Z=function(){},$=function(){},_={height:function(){return x("Custom height calculation function not defined"),document.documentElement.offsetHeight},width:function(){return x("Custom width calculation function not defined"),document.body.scrollWidth}},ee={},te=!1;try{var ne=Object.create({},{passive:{get:function(){te=!0}}});window.addEventListener("test",ae,ne),window.removeEventListener("test",ae,ne)}catch(e){}var oe,o,I,ie,N,A,C={bodyOffset:function(){return document.body.offsetHeight+ye("marginTop")+ye("marginBottom")},offset:function(){return C.bodyOffset()},bodyScroll:function(){return document.body.scrollHeight},custom:function(){return _.height()},documentElementOffset:function(){return document.documentElement.offsetHeight},documentElementScroll:function(){return document.documentElement.scrollHeight},max:function(){return Math.max.apply(null,e(C))},min:function(){return Math.min.apply(null,e(C))},grow:function(){return C.max()},lowestElement:function(){return Math.max(C.bodyOffset()||C.documentElementOffset(),we("bottom",Te()))},taggedElement:function(){return be("bottom","data-iframe-height")}},z={bodyScroll:function(){return document.body.scrollWidth},bodyOffset:function(){return document.body.offsetWidth},custom:function(){return _.width()},documentElementScroll:function(){return document.documentElement.scrollWidth},documentElementOffset:function(){return document.documentElement.offsetWidth},scroll:function(){return Math.max(z.bodyScroll(),z.documentElementScroll())},max:function(){return Math.max.apply(null,e(z))},min:function(){return Math.min.apply(null,e(z))},rightMostElement:function(){return we("right",Te())},taggedElement:function(){return be("right","data-iframe-width")}},re=(oe=Ee,N=null,A=0,function(){var e=Date.now(),t=O-(e-(A=A||e));return o=this,I=arguments,t<=0||O<t?(N&&(clearTimeout(N),N=null),A=e,ie=oe.apply(o,I),N||(o=I=null)):N=N||setTimeout(Oe,t),ie});k(window,"message",function(t){var n={init:function(){W=t.data,X=t.source,se(),q=!1,setTimeout(function(){H=!1},l)},reset:function(){H?R("Page reset ignored by init"):(R("Page size reset by host page"),Me("resetPage"))},resize:function(){L("resizeParent","Parent window requested size check")},moveToAnchor:function(){h.findTarget(i())},inPageLink:function(){this.moveToAnchor()},pageInfo:function(){var e=i();R("PageInfoFromParent called from parent: "+e),$(JSON.parse(e)),R(" --")},message:function(){var e=i();R("onMessage called from parent: "+e),G(JSON.parse(e)),R(" --")}};function o(){return t.data.split("]")[1].split(":")[0]}function i(){return t.data.slice(t.data.indexOf(":")+1)}function r(){return t.data.split(":")[2]in{true:1,false:1}}function e(){var e=o();e in n?n[e]():("undefined"==typeof module||!module.exports)&&"iFrameResize"in window||window.jQuery!==a&&"iFrameResize"in window.jQuery.prototype||r()||x("Unexpected message ("+t.data+")")}y===(""+t.data).slice(0,J)&&(!1===q?e():r()?n.init():R('Ignored message of type "'+o()+'". Received before initialization.'))}),k(window,"readystatechange",Ne),Ne()}function ae(){}function k(e,t,n,o){e.addEventListener(t,n,!!te&&(o||{}))}function ue(e){return e.charAt(0).toUpperCase()+e.slice(1)}function ce(e){return y+"["+w+"] "+e}function R(e){p&&"object"==typeof window.console&&console.log(ce(e))}function x(e){"object"==typeof window.console&&console.warn(ce(e))}function se(){function e(e){return"true"===e}function t(e,t){return"function"==typeof e&&(R("Setup custom "+t+"CalcMethod"),_[t]=e,e="custom"),e}{var n;n=W.slice(J).split(":"),w=n[0],u=a===n[1]?u:Number(n[1]),d=a===n[2]?d:e(n[2]),p=a===n[3]?p:e(n[3]),g=a===n[4]?g:Number(n[4]),r=a===n[6]?r:e(n[6]),c=n[7],m=a===n[8]?m:n[8],P=n[9],D=n[10],E=a===n[11]?E:Number(n[11]),h.enable=a!==n[12]&&e(n[12]),b=a===n[13]?b:n[13],M=a===n[14]?M:n[14],v=a===n[15]?v:e(n[15]),R("Initialising iFrame ("+window.location.href+")"),"iFrameResizer"in window&&Object===window.iFrameResizer.constructor&&(n=window.iFrameResizer,R("Reading data from page: "+JSON.stringify(n)),Object.keys(n).forEach(de,n),G="onMessage"in n?n.onMessage:G,Z="onReady"in n?n.onReady:Z,T="targetOrigin"in n?n.targetOrigin:T,m="heightCalculationMethod"in n?n.heightCalculationMethod:m,M="widthCalculationMethod"in n?n.widthCalculationMethod:M,m=t(m,"height"),M=t(M,"width"))}function o(e){F(0,0,e.type,e.screenY+":"+e.screenX)}function i(e,t){R("Add event listener: "+t),k(window.document,e,o)}R("TargetOrigin for parent set to: "+T),le("margin",function(e,t){-1!==t.indexOf("-")&&(x("Negative CSS value ignored for "+e),t="");return t}("margin",c=a===c?u+"px":c)),le("background",P),le("padding",D),(n=document.createElement("div")).style.clear="both",n.style.display="block",n.style.height="0",document.body.appendChild(n),he(),ge(),document.documentElement.style.height="",document.body.style.height="",R('HTML & body height set to "auto"'),R("Enable public methods"),Q.parentIFrame={autoResize:function(e){return!0===e&&!1===r?(r=!0,pe()):!1===e&&!0===r&&(r=!1,fe("remove"),null!==s&&s.disconnect(),clearInterval(B)),F(0,0,"autoResize",JSON.stringify(r)),r},close:function(){F(0,0,"close")},getId:function(){return w},getPageInfo:function(e){"function"==typeof e?($=e,F(0,0,"pageInfo")):($=function(){},F(0,0,"pageInfoStop"))},moveToAnchor:function(e){h.findTarget(e)},reset:function(){Ie("parentIFrame.reset")},scrollTo:function(e,t){F(t,e,"scrollTo")},scrollToOffset:function(e,t){F(t,e,"scrollToOffset")},sendMessage:function(e,t){F(0,0,"message",JSON.stringify(e),t)},setHeightCalculationMethod:function(e){m=e,he()},setWidthCalculationMethod:function(e){M=e,ge()},setTargetOrigin:function(e){R("Set targetOrigin: "+e),T=e},size:function(e,t){L("size","parentIFrame.size("+((e||"")+(t?","+t:""))+")",e,t)}},!0===v&&(i("mouseenter","Mouse Enter"),i("mouseleave","Mouse Leave")),pe(),h=function(){function n(e){var e=e.getBoundingClientRect(),t={x:window.pageXOffset===a?document.documentElement.scrollLeft:window.pageXOffset,y:window.pageYOffset===a?document.documentElement.scrollTop:window.pageYOffset};return{x:parseInt(e.left,10)+parseInt(t.x,10),y:parseInt(e.top,10)+parseInt(t.y,10)}}function o(e){var e=e.split("#")[1]||e,t=decodeURIComponent(e),t=document.getElementById(t)||document.getElementsByName(t)[0];a===t?(R("In page link (#"+e+") not found in iFrame, so sending to parent"),F(0,0,"inPageLink","#"+e)):(t=n(t=t),R("Moving to in page link (#"+e+") at x: "+t.x+" y: "+t.y),F(t.y,t.x,"scrollToOffset"))}function e(){var e=window.location.hash,t=window.location.href;""!==e&&"#"!==e&&o(t)}function t(){Array.prototype.forEach.call(document.querySelectorAll('a[href^="#"]'),function(e){"#"!==e.getAttribute("href")&&k(e,"click",function(e){e.preventDefault(),o(this.getAttribute("href"))})})}function i(){Array.prototype.forEach&&document.querySelectorAll?(R("Setting up location.hash handlers"),t(),k(window,"hashchange",e),setTimeout(e,l)):x("In page linking not fully supported in this browser! (See README.md for IE8 workaround)")}h.enable?i():R("In page linking not enabled");return{findTarget:o}}(),L("init","Init message from host page"),Z()}function de(e){var t=e.split("Callback");2===t.length&&(this[t="on"+t[0].charAt(0).toUpperCase()+t[0].slice(1)]=this[e],delete this[e],x("Deprecated: '"+e+"' has been renamed '"+t+"'. The old method will be removed in the next major version."))}function le(e,t){a!==t&&""!==t&&"null"!==t&&R("Body "+e+' set to "'+(document.body.style[e]=t)+'"')}function t(n){var e={add:function(e){function t(){L(n.eventName,n.eventType)}ee[e]=t,k(window,e,t,{passive:!0})},remove:function(e){var t=ee[e];delete ee[e],window.removeEventListener(e,t,!1)}};n.eventNames&&Array.prototype.map?(n.eventName=n.eventNames[0],n.eventNames.map(e[n.method])):e[n.method](n.eventName),R(ue(n.method)+" event listener: "+n.eventType)}function fe(e){t({method:e,eventType:"Animation Start",eventNames:["animationstart","webkitAnimationStart"]}),t({method:e,eventType:"Animation Iteration",eventNames:["animationiteration","webkitAnimationIteration"]}),t({method:e,eventType:"Animation End",eventNames:["animationend","webkitAnimationEnd"]}),t({method:e,eventType:"Input",eventName:"input"}),t({method:e,eventType:"Mouse Up",eventName:"mouseup"}),t({method:e,eventType:"Mouse Down",eventName:"mousedown"}),t({method:e,eventType:"Orientation Change",eventName:"orientationchange"}),t({method:e,eventType:"Print",eventNames:["afterprint","beforeprint"]}),t({method:e,eventType:"Ready State Change",eventName:"readystatechange"}),t({method:e,eventType:"Touch Start",eventName:"touchstart"}),t({method:e,eventType:"Touch End",eventName:"touchend"}),t({method:e,eventType:"Touch Cancel",eventName:"touchcancel"}),t({method:e,eventType:"Transition Start",eventNames:["transitionstart","webkitTransitionStart","MSTransitionStart","oTransitionStart","otransitionstart"]}),t({method:e,eventType:"Transition Iteration",eventNames:["transitioniteration","webkitTransitionIteration","MSTransitionIteration","oTransitionIteration","otransitioniteration"]}),t({method:e,eventType:"Transition End",eventNames:["transitionend","webkitTransitionEnd","MSTransitionEnd","oTransitionEnd","otransitionend"]}),"child"===b&&t({method:e,eventType:"IFrame Resized",eventName:"resize"})}function me(e,t,n,o){return t!==e&&(e in n||(x(e+" is not a valid option for "+o+"CalculationMethod."),e=t),R(o+' calculation method set to "'+e+'"')),e}function he(){m=me(m,n,C,"height")}function ge(){M=me(M,K,z,"width")}function pe(){var e;!0===r?(fe("add"),e=g<0,window.MutationObserver||window.WebKitMutationObserver?e?ve():s=function(){function t(e){function t(e){!1===e.complete&&(R("Attach listeners to "+e.src),e.addEventListener("load",i,!1),e.addEventListener("error",r,!1),u.push(e))}"attributes"===e.type&&"src"===e.attributeName?t(e.target):"childList"===e.type&&Array.prototype.forEach.call(e.target.querySelectorAll("img"),t)}function o(e){R("Remove listeners from "+e.src),e.removeEventListener("load",i,!1),e.removeEventListener("error",r,!1),u.splice(u.indexOf(e),1)}function n(e,t,n){o(e.target),L(t,n+": "+e.target.src)}function i(e){n(e,"imageLoad","Image loaded")}function r(e){n(e,"imageLoadFailed","Image load failed")}function a(e){L("mutationObserver","mutationObserver: "+e[0].target+" "+e[0].type),e.forEach(t)}var u=[],c=window.MutationObserver||window.WebKitMutationObserver,s=function(){var e=document.querySelector("body");return s=new c(a),R("Create body MutationObserver"),s.observe(e,{attributes:!0,attributeOldValue:!1,characterData:!0,characterDataOldValue:!1,childList:!0,subtree:!0}),s}();return{disconnect:function(){"disconnect"in s&&(R("Disconnect body MutationObserver"),s.disconnect(),u.forEach(o))}}}():(R("MutationObserver not supported in this browser!"),ve())):R("Auto Resize disabled")}function ve(){0!==g&&(R("setInterval: "+g+"ms"),B=setInterval(function(){L("interval","setInterval: "+g)},Math.abs(g)))}function ye(e,t){return t=t||document.body,t=null===(t=document.defaultView.getComputedStyle(t,null))?0:t[e],parseInt(t,10)}function we(e,t){for(var n,o=t.length,i=0,r=ue(e),a=Date.now(),u=0;u<o;u++)i<(n=t[u].getBoundingClientRect()[e]+ye("margin"+r,t[u]))&&(i=n);return a=Date.now()-a,R("Parsed "+o+" HTML elements"),R("Element position calculated in "+a+"ms"),O/2<(a=a)&&R("Event throttle increased to "+(O=2*a)+"ms"),i}function e(e){return[e.bodyOffset(),e.bodyScroll(),e.documentElementOffset(),e.documentElementScroll()]}function be(e,t){var n=document.querySelectorAll("["+t+"]");return 0===n.length&&(x("No tagged elements ("+t+") found on page"),document.querySelectorAll("body *")),we(e,n)}function Te(){return document.querySelectorAll("body *")}function Ee(e,t,n,o){function i(){e in{init:1,interval:1,size:1}||!(m in U||d&&M in U)?e in{interval:1}||R("No change in size detected"):Ie(t)}function r(e,t){return!(Math.abs(e-t)<=E)}n=a===n?C[m]():n,o=a===o?z[M]():o,r(f,n)||d&&r(S,o)||"init"===e?(Se(),F(f=n,S=o,e)):i()}function Oe(){A=Date.now(),N=null,ie=oe.apply(o,I),N||(o=I=null)}function L(e,t,n,o){i&&e in j?R("Trigger event cancelled: "+e):(e in{reset:1,resetPage:1,init:1}||R("Trigger event: "+t),("init"===e?Ee:re)(e,t,n,o))}function Se(){i||(i=!0,R("Trigger event lock on")),clearTimeout(Y),Y=setTimeout(function(){i=!1,R("Trigger event lock off"),R("--")},l)}function Me(e){f=C[m](),S=z[M](),F(f,S,e)}function Ie(e){var t=m;m=n,R("Reset trigger event: "+e),Se(),Me("reset"),m=t}function F(e,t,n,o,i){!0===V&&(a===i?i=T:R("Message targetOrigin: "+i),R("Sending message to host page ("+(e=w+":"+(e+":"+t)+":"+n+(a===o?"":":"+o))+")"),X.postMessage(y+e,i))}function Ne(){"loading"!==document.readyState&&window.parent.postMessage("[iFrameResizerChild]Ready","*")}}();
//# sourceMappingURL=iframeResizer.contentWindow.map
/* KAVELKIEZER V3
   Wijzigingen 9 september 2026:
   - --kk-image-ratio op de wrapper gezet per aanzicht (voor schermvullend beeld)
   - slepen ook op zoomniveau 1 wanneer het beeld groter is dan de container
   - momentum na loslaten, met bounce op de randen
   - breedte weergavetoggle als --kk-toggle-width voor de positie van de filterknop
   - optioneel per project: data-download, data-download-label, data-interesse,
     data-interesse-label op de polygonen; data-no-detail op de app schakelt de
     doorklik naar de detailpagina uit; spec-tags zonder waarde worden verborgen
   - data-lot-prefix op de app (standaard "Woning"), #detailsSubtitle met woningtype
   - data-focus op een aanzicht of data-initial-focus op de app: left / center / right
   - twee aanzichten: segmented toggle onderaan in plaats van dropdown
   - mobiele melding #kavelNotice, sluitbaar, eenmalig per sessie
   - slepen op zoomniveau 1 alleen horizontaal, verticale veeg scrolt de pagina
     (touch-action: pan-y); ingezoomd in beide richtingen */
(function() {
    'use strict';

    const mapViewsContainer = document.getElementById('mapViews');
    if (!mapViewsContainer) return;

    // Korte helper voor getElementById
    const $ = id => document.getElementById(id);

    const wrapper    = $('mapWrapper'),   svg       = $('kavelSvg'),
          bgImg      = $('mapCanvas'),    tooltip   = $('kavelTooltip'),
          tooltipOverview = $('kavelTooltipOverview'),
          panel      = $('detailsPanel'), overlayBg = $('overlayBg'),
          mapContainer = document.querySelector('.map-container'),
          kavelApp   = $('kavelApp'),
          btnBackOverview = $('btnBackOverview');

    if (!wrapper || !svg || !bgImg || !tooltip || !panel || !overlayBg || !mapContainer) {
        console.warn('Kavelkiezer: niet alle vereiste elementen aanwezig'); return;
    }

    const viewMapBtn = $('viewMapBtn'), viewListBtn = $('viewListBtn'),
          viewMapBtnMobile = $('viewMapBtnMobile'), viewListBtnMobile = $('viewListBtnMobile'),
          pricelistContainer = $('pricelistContainer'), pricelistBody = $('pricelistBody'),
          pricelistEmpty = $('pricelistEmpty'), filterStatus = $('filterStatus'),
          filterType = $('filterType'), filterModel = $('filterModel'),
          filterBedrooms = $('filterBedrooms'), resetBtn = $('resetFilters'),
          resultsCounter = $('resultsCounter'), mobileResultsCounter = $('mobileResultsCounter'),
          mobileFilterBtn = $('mobileFilterBtn'), mobileFilterBadge = $('mobileFilterBadge'),
          filterDrawer = $('filterDrawer'), filterDrawerOverlay = $('filterDrawerOverlay'),
          filterDrawerClose = $('filterDrawerClose'), filterDrawerReset = $('filterDrawerReset'),
          filterDrawerApply = $('filterDrawerApply'), filterStatusMobile = $('filterStatusMobile'),
          filterTypeMobile = $('filterTypeMobile'), filterModelMobile = $('filterModelMobile'),
          filterBedroomsMobile = $('filterBedroomsMobile'), moreFiltersBtn = $('moreFiltersBtn'),
          moreFiltersDropdown = $('moreFiltersDropdown'), moreFiltersBadge = $('moreFiltersBadge'),
          filterModelDropdown = $('filterModelDropdown'), filterBedroomsDropdown = $('filterBedroomsDropdown'),
          viewSelect = $('viewSelect'), viewPrev = $('viewPrev'), viewNext = $('viewNext');

    // Views inladen — .d-none views worden overgeslagen (handig om overview
    // of een detail-view tijdelijk uit te schakelen zonder HTML te verwijderen)
    const mapViews = Array.from(mapViewsContainer.querySelectorAll('.map-view'))
        .filter(v => !v.classList.contains('d-none'));
    const views = mapViews.map((v, i) => ({
        index: i, id: v.dataset.id, label: v.dataset.label,
        background: v.dataset.background, viewBox: v.dataset.vb || '0 0 1920 1080',
        type: v.dataset.viewType || 'detail'  // 'overview' of 'detail'
    }));

    // Indices van detail-views (voor prev/next navigatie, zonder overview)
    const detailViewIndices = views.map((v, i) => v.type === 'detail' ? i : -1).filter(i => i >= 0);
    const overviewIndex = views.findIndex(v => v.type === 'overview');
    const hasOverview = overviewIndex >= 0;

    // View-select dropdown vullen (overview krijgt een visueel onderscheid)
    views.forEach((v, i) => {
        const opt = document.createElement('option');
        opt.value = i;
        opt.textContent = v.type === 'overview' ? '↩ ' + v.label : v.label;
        viewSelect.appendChild(opt);
    });

    // --- Helpers ---
    function parsePrice(s) {
        const m = s && s.match(/€?\s*([\d.,]+)/);
        return m ? parseInt(m[1].replace(/[^\d]/g, '')) || 0 : 0;
    }
    function parseM2(s) {
        const m = s && s.match(/(\d+)/);
        return m ? parseInt(m[1]) : 0;
    }
    function formatPriceShort(v) {
        return v >= 1000000 ? '€' + (v / 1000000).toFixed(1) + 'M' : '€' + Math.round(v / 1000) + 'k';
    }
    function statusToKey(s) {
        return s ? s.toLowerCase().trim().replace(/\s+/g, '-') : 'toekomstig';
    }
    // Stel tekst in van element (null-safe)
    function setText(id, text) { const e = $(id); if (e) e.textContent = text; }
    // Toon/verberg dd + bijbehorende dt
    function showDd(id, show) {
        const e = $(id); if (!e) return;
        e.style.display = show ? '' : 'none';
        if (e.previousElementSibling) e.previousElementSibling.style.display = e.style.display;
    }
    // Toon/verberg spec-tag
    function showTag(id, show) { const e = $(id); if (e) e.style.display = show ? '' : 'none'; }

    // Voorvoegsel voor het bouwnummer in paneel, tooltip en prijslijst.
    // data-lot-prefix="" op de app haalt het weg (bijv. bij losse kavels).
    const lotPrefix = kavelApp.dataset.lotPrefix !== undefined ? kavelApp.dataset.lotPrefix : 'Woning';
    function lotLabel(bouwnummer) {
        return bouwnummer ? (lotPrefix ? lotPrefix + ' ' + bouwnummer : bouwnummer) : '';
    }

    // Check of huidige view een overview is
    function isOverviewView() {
        return views[currentViewIndex] && views[currentViewIndex].type === 'overview';
    }

    // Status → leesbaar label
    const STATUS_LABELS = {
        'available':'Beschikbaar','beschikbaar':'Beschikbaar','vrij':'Beschikbaar','te-koop':'Te koop',
        'option':'Onder optie','optie':'Onder optie','onder-optie':'Onder optie','in-optie':'Onder optie',
        'onder-bod':'Onder bod','oral-agreement':'Mondeling verkocht','mondeling-verkocht':'Mondeling verkocht',
        'verhuurd':'Verhuurd','verhuurd-onder-voorbehoud':'Verhuurd o.v.',
        'sold':'Verkocht','verkocht':'Verkocht','verkoht':'Verkocht',
        'verkocht-onder-voorbehoud':'Verkocht o.v.','future':'Toekomstig','toekomstig':'Toekomstig',
        'in-aanmelding':'In aanmelding','nog-niet-in-verkoop':'Nog niet in verkoop','binnenkort':'Binnenkort',
        'binnenkort-in-verkoop':'Binnenkort in verkoop','in-voorbereiding':'In voorbereiding',
    };
    function statusToLabel(s) { return STATUS_LABELS[statusToKey(s)] || s || 'Toekomstig'; }

    // Status → badge CSS klasse (panel + tooltip)
    const BADGE = {
        'available':'bg-success text-white','beschikbaar':'bg-success text-white',
        'vrij':'bg-success text-white','te-koop':'bg-success text-white',
        'option':'bg-warning text-dark','optie':'bg-warning text-dark',
        'onder-optie':'bg-warning text-dark','in-optie':'bg-warning text-dark','onder-bod':'bg-warning text-dark',
        'oral-agreement':'bg-oral-agreement','mondeling-verkocht':'bg-oral-agreement',
        'verhuurd':'bg-rented','verhuurd-onder-voorbehoud':'bg-rented',
        'sold':'bg-danger','verkocht':'bg-danger','verkoht':'bg-danger',
        'verkocht-onder-voorbehoud':'bg-sold-option', 'binnenkort-in-verkoop':'bg-success text-white',
    };
    function statusToBadgeClass(s) { return BADGE[statusToKey(s)] || 'bg-future'; }

    const TOOLTIP_BADGE = {
        'available':'bg-available','beschikbaar':'bg-available','vrij':'bg-available','te-koop':'bg-available',
        'option':'bg-option','optie':'bg-option','onder-optie':'bg-option','in-optie':'bg-option','onder-bod':'bg-option',
        'oral-agreement':'bg-oral-agreement','mondeling-verkocht':'bg-oral-agreement',
        'verhuurd':'bg-rented','verhuurd-onder-voorbehoud':'bg-rented',
        'sold':'bg-sold','verkocht':'bg-sold','verkoht':'bg-sold','verkocht-onder-voorbehoud':'bg-sold-option',
        'binnenkort-in-verkoop':'bg-available',
    };
    function statusToTooltipBadge(s) { return TOOLTIP_BADGE[statusToKey(s)] || 'bg-future'; }

    // Situatie codes → leesbare labels
    const SITUATIE = {
        'water':'Aan water','clear_view':'Vrij uitzicht','rural':'Landelijk',
        'forest':'Aan bos','park':'Aan park','open':'Open ligging',
        'sheltered':'Beschut','sea_view':'Zeezicht'
    };
    function situatieToLabels(s) {
        return s ? s.split(',').map(x => SITUATIE[x.trim()]).filter(Boolean) : [];
    }

    // Parkeren → leesbare tekst
    const PARKEER = { 'private':'Eigen parkeren','garage':'Garage','carport':'Carport','public':'Openbaar','paid':'Betaald parkeren' };
    function parkerenLabel(fac, cap) {
        if (!fac || fac === 'none') return '';
        const label = PARKEER[fac] || fac;
        return (cap && parseInt(cap) > 0) ? label + ' (' + cap + ' pl.)' : label;
    }

    // --- Data analyse ---
    function analyzeKavelData() {
        const statuses = new Set(), types = new Set(), models = new Set(), bedrooms = new Set();
        let minP = Infinity, maxP = 0, minM = Infinity, maxM = 0, minPc = Infinity, maxPc = 0, total = 0;
        const seen = new Set();
        // Alleen detail-views scannen (overview bevat side-polygons, geen woningen)
        mapViews.forEach(view => {
            if (view.dataset.viewType === 'overview') return;
            view.querySelectorAll('path').forEach(p => {
                if (seen.has(p.dataset.id)) return;
                seen.add(p.dataset.id); total++;
                if (p.dataset.status) statuses.add(statusToKey(p.dataset.status));
                if (p.dataset.naam) types.add(p.dataset.naam);
                if (p.dataset.typewoning) models.add(p.dataset.typewoning);
                const bed = (p.dataset.aantalKamers || p.dataset.aantalSlaapkamers || '').replace(/[^\d]/g, '');
                if (bed) bedrooms.add(bed);
                const pr = parsePrice(p.dataset.prijs); if (pr > 0) { minP = Math.min(minP, pr); maxP = Math.max(maxP, pr); }
                const m2 = parseM2(p.dataset.woonoppervlakte); if (m2 > 0) { minM = Math.min(minM, m2); maxM = Math.max(maxM, m2); }
                const pc = parseM2(p.dataset.perceeloppervlakte); if (pc > 0) { minPc = Math.min(minPc, pc); maxPc = Math.max(maxPc, pc); }
            });
        });
        return {
            statuses: [...statuses], types: [...types].sort(), models: [...models].sort(),
            bedrooms: [...bedrooms].sort((a, b) => a - b), total,
            priceRange:  { min: minP  === Infinity ? 0 : minP,  max: maxP  },
            m2Range:     { min: minM  === Infinity ? 0 : minM,  max: maxM  },
            perceelRange:{ min: minPc === Infinity ? 0 : minPc, max: maxPc }
        };
    }
    const kavelData = analyzeKavelData();

    // --- Filters setup ---
    function setFilterVisible(id, visible) {
        const e = $(id); if (e) e.classList.toggle('filter-hidden', !visible);
    }
    function addOptions(selects, items, labelFn) {
        selects.forEach(sel => {
            if (!sel) return;
            items.forEach(v => { const o = document.createElement('option'); o.value = v; o.textContent = labelFn ? labelFn(v) : v; sel.appendChild(o); });
        });
    }

    function setupFilters() {
        const { statuses, types, models, bedrooms, priceRange: pr, m2Range: m2, perceelRange: pc, total: n } = kavelData;

        const showSt = n > 0 && statuses.length > 1;
        setFilterVisible('filterStatusWrap', showSt); setFilterVisible('filterStatusMobileWrap', showSt);
        if (showSt) {
            const order = ['available','option','oral-agreement','rented','sold','future'];
            addOptions([filterStatus, filterStatusMobile], [...statuses].sort((a, b) => order.indexOf(a) - order.indexOf(b)), statusToLabel);
        }

        const showTy = n > 0 && types.length > 1;
        setFilterVisible('filterTypeWrap', showTy); setFilterVisible('filterTypeMobileWrap', showTy);
        if (showTy) addOptions([filterType, filterTypeMobile], types);

        const showMo = n > 0 && models.length > 1;
        ['filterModelWrap','filterModelMobileWrap','filterModelWrapDropdown'].forEach(id => setFilterVisible(id, showMo));
        if (showMo) addOptions([filterModel, filterModelMobile, filterModelDropdown], models);

        const showBed = n > 0 && bedrooms.length > 1;
        ['filterBedroomsWrap','filterBedroomsMobileWrap','filterBedroomsWrapDropdown'].forEach(id => setFilterVisible(id, showBed));
        if (showBed) addOptions([filterBedrooms, filterBedroomsMobile, filterBedroomsDropdown], bedrooms,
            b => b + ' slaapkamer' + (parseInt(b) !== 1 ? 's' : ''));

        const showPr = n > 0 && pr.max > 0 && pr.min < pr.max;
        const showM2 = n > 0 && m2.max > 0 && m2.min < m2.max;
        const showPc = n > 0 && pc.max > 0 && pc.min < pc.max;
        ['filterPriceWrap','filterPriceMobileWrap'].forEach(id => setFilterVisible(id, showPr));
        ['filterM2Wrap','filterM2MobileWrap','filterM2WrapDropdown'].forEach(id => setFilterVisible(id, showM2));
        ['filterPerceelWrap','filterPerceelMobileWrap','filterPerceelWrapDropdown'].forEach(id => setFilterVisible(id, showPc));
        return { showPr, showM2, showPc, pr, m2, pc };
    }
    const fc = setupFilters(); // fc = filterConfig

    // --- State ---
    let activeStatusFilter = '', activeTypeFilter = '', activeModelFilter = '', activeBedroomsFilter = '';
    let activeView = 'map', sortColumn = 'bouwnummer', sortDirection = 'asc', isInitialized = false;

    const priceMin = fc.showPr ? Math.floor(fc.pr.min / 10000) * 10000 : 200000;
    const priceMax = fc.showPr ? Math.ceil(fc.pr.max / 10000) * 10000  : 1000000;
    const m2Min    = fc.showM2 ? Math.floor(fc.m2.min / 5) * 5         : 40;
    const m2Max    = fc.showM2 ? Math.ceil(fc.m2.max / 5) * 5          : 200;
    const pcMin    = fc.showPc ? Math.floor(fc.pc.min / 10) * 10       : 100;
    const pcMax    = fc.showPc ? Math.ceil(fc.pc.max / 10) * 10        : 500;

    let priceRange = [priceMin, priceMax], m2Range = [m2Min, m2Max], pcRange = [pcMin, pcMax];
    let isOpen = false, pinnedId = null, currentViewIndex = 0, scale = 1, panX = 0, panY = 0;
    const MIN_SCALE = 1, MAX_SCALE = 5;

    // --- Kavel data verzamelen ---
    // BELANGRIJK: moet VOOR createSlider() declareerd zijn, omdat de slider-init
    // callbacks direct applyFilters() kunnen triggeren die allKavels gebruikt.
    function getAllKavels() {
        const kavels = [], seen = new Set();
        // Alleen detail-views scannen
        mapViews.forEach(view => {
            if (view.dataset.viewType === 'overview') return;
            view.querySelectorAll('path').forEach(p => {
                if (seen.has(p.dataset.id)) return;
                seen.add(p.dataset.id);
                const d = p.dataset, km = d.aantalKamers || d.aantalSlaapkamers || '';
                const m2str = val => val && parseFloat(val) !== 0 ? val + ' m\u00B2' : '';
                kavels.push({
                    id: d.id, bouwnummer: d.bouwnummer || '', naam: d.naam || '', typewoning: d.typewoning || '',
                    prijs: d.prijs || '', prijsNum: parsePrice(d.prijs), status: statusToKey(d.status),
                    woonoppervlakte: m2str(d.woonoppervlakte), woonoppervlakteNum: parseM2(d.woonoppervlakte),
                    perceeloppervlakte: m2str(d.perceeloppervlakte), perceeloppervlakteNum: parseM2(d.perceeloppervlakte),
                    buitenruimte: d.buitenruimte || '', verdieping: d.verdieping || '', aantalKamers: km,
                    ligging: d.ligging || '', afbeelding: d.afbeelding || '', info: d.info || '',
                    woonlastenUrl: d.woonlastenUrl || '',
                    volume: d.volume && parseFloat(d.volume) > 0 ? d.volume : '',
                    kamersTotaal: d.kamersTotaal && parseInt(d.kamersTotaal) > 0 ? d.kamersTotaal : '',
                    parkeren: parkerenLabel(d.parkeren, d.parkerenAantal),
                    situatie: d.situatie || '',
                    // optioneel per project: downloadlink (kavelpaspoort, bouwtekening) en
                    // interesse-link (tel: of mailto:) in plaats van doorklik naar detailpagina
                    download: d.download || '', downloadLabel: d.downloadLabel || 'Download',
                    interesse: d.interesse || '', interesseLabel: d.interesseLabel || 'Ik heb interesse'
                });
            });
        });
        return kavels;
    }
    const allKavels = getAllKavels();

    // --- Dual range sliders ---
    function createSlider(container, start, range, step, onUpdate) {
        if (!container) return null;
        const { min, max } = range;
        let v = [...start];
        const cbs = [];
        container.innerHTML = `<div class="dual-range-slider"><div class="dual-range-track"></div><div class="dual-range-fill"></div><input type="range" class="range-min" min="${min}" max="${max}" step="${step}" value="${start[0]}"><input type="range" class="range-max" min="${min}" max="${max}" step="${step}" value="${start[1]}"></div>`;
        const fill = container.querySelector('.dual-range-fill');
        const rMin = container.querySelector('.range-min');
        const rMax = container.querySelector('.range-max');
        function updateFill() {
            fill.style.left  = ((v[0] - min) / (max - min) * 100) + '%';
            fill.style.width = ((v[1] - v[0]) / (max - min) * 100) + '%';
        }
        rMin.addEventListener('input', () => {
            v[0] = Math.min(parseInt(rMin.value), v[1] - step); rMin.value = v[0]; updateFill(); onUpdate([...v]);
        });
        rMax.addEventListener('input', () => {
            v[1] = Math.max(parseInt(rMax.value), v[0] + step); rMax.value = v[1]; updateFill(); onUpdate([...v]);
        });
        rMin.addEventListener('change', () => cbs.forEach(cb => cb([...v])));
        rMax.addEventListener('change', () => cbs.forEach(cb => cb([...v])));
        updateFill(); onUpdate([...v]);
        return {
            get: () => [...v],
            set: nv => { v = [...nv]; rMin.value = v[0]; rMax.value = v[1]; updateFill(); onUpdate([...v]); },
            on: (ev, cb) => { if (ev === 'change') cbs.push(cb); }
        };
    }

    let priceSlider = null, priceSliderMobile = null, m2Slider = null, m2SliderMobile = null,
        pcSlider = null, pcSliderMobile = null, m2SliderDD = null, pcSliderDD = null;

    if (fc.showPr) {
        priceSlider       = createSlider($('priceSlider'),       [priceMin, priceMax], { min: priceMin, max: priceMax }, 10000, v => { priceRange = v; setText('priceValue', formatPriceShort(v[0]) + ' - ' + formatPriceShort(v[1])); applyFilters(); });
        priceSliderMobile = createSlider($('priceSliderMobile'), [priceMin, priceMax], { min: priceMin, max: priceMax }, 10000, v => setText('priceValueMobile', '€ ' + Number(v[0]).toLocaleString('nl-NL') + ' - € ' + Number(v[1]).toLocaleString('nl-NL')));
    }
    if (fc.showM2) {
        m2Slider    = createSlider($('m2Slider'),       [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, v => { m2Range = v; setText('m2Value', v[0] + ' - ' + v[1] + ' m\u00B2'); applyFilters(); });
        m2SliderMobile = createSlider($('m2SliderMobile'), [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, v => setText('m2ValueMobile', v[0] + ' - ' + v[1] + ' m\u00B2'));
        m2SliderDD  = createSlider($('m2SliderDropdown'), [m2Min, m2Max], { min: m2Min, max: m2Max }, 5, v => { m2Range = v; setText('m2ValueDropdown', v[0] + ' - ' + v[1] + ' m\u00B2'); if (m2Slider) m2Slider.set(v); applyFilters(); });
    }
    if (fc.showPc) {
        pcSlider       = createSlider($('perceelSlider'),       [pcMin, pcMax], { min: pcMin, max: pcMax }, 10, v => { pcRange = v; setText('perceelValue', v[0] + ' - ' + v[1] + ' m\u00B2'); applyFilters(); });
        pcSliderMobile = createSlider($('perceelSliderMobile'), [pcMin, pcMax], { min: pcMin, max: pcMax }, 10, v => setText('perceelValueMobile', v[0] + ' - ' + v[1] + ' m\u00B2'));
        pcSliderDD     = createSlider($('perceelSliderDropdown'), [pcMin, pcMax], { min: pcMin, max: pcMax }, 10, v => { pcRange = v; setText('perceelValueDropdown', v[0] + ' - ' + v[1] + ' m\u00B2'); if (pcSlider) pcSlider.set(v); applyFilters(); });
    }

    // --- Render view ---
    function renderView(idx) {
        const view = views[idx], viewEl = mapViews[idx];
        if (!view || !viewEl) return;
        bgImg.src = view.background;
        svg.setAttribute('viewBox', view.viewBox);
        const [,, vw, vh] = view.viewBox.split(' ').map(Number);
        if (vw && vh) {
            wrapper.style.aspectRatio = vw + ' / ' + vh;
            // Verhouding ook als css-variabele, voor het schermvullende beeld
            wrapper.style.setProperty('--kk-image-ratio', (vw / vh).toFixed(4));
        }
        svg.innerHTML = '';

        // Is dit een overview-view of een detail-view?
        const isOverview = view.type === 'overview';

        // Kopieer alle paths uit de bron-view naar de live SVG
        viewEl.querySelectorAll('path').forEach(p => {
            const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
            Array.from(p.attributes).forEach(a => path.setAttribute(a.name, a.value));
            svg.appendChild(path);
        });

        // Op detail-views: status-classes toevoegen op basis van data-status
        if (!isOverview) {
            svg.querySelectorAll('.hover-area').forEach(path => {
                Array.from(path.classList).filter(c => c.startsWith('status-')).forEach(c => path.classList.remove(c));
                path.classList.add('status-' + statusToKey(path.dataset.status));
            });
        }

        // Update app-class voor overview-modus (stuurt CSS voor filterbar e.d.)
        kavelApp.classList.toggle('is-overview', isOverview);

        // Terug-knop tonen/verbergen: alleen op detail-views EN als er een overview bestaat
        if (btnBackOverview) {
            btnBackOverview.classList.toggle('is-visible', hasOverview && !isOverview);
        }

        // Op overview: filters mogen niet effectief zijn (alles wordt overschreven naar getoond)
        // maar we resetten ze NIET — gebruiker behoudt filters als ze terugkeren naar detail-view

        // Side-labels renderen op overview, anders opruimen
        if (isOverview) {
            // Wacht tot de browser SVG heeft gelayout (nodig voor getBBox)
            requestAnimationFrame(() => renderSideLabels());
        } else {
            clearSideLabels();
        }

        if (typeof stopMomentum === 'function') stopMomentum();
        scale = 1; panX = 0; panY = 0;
        applyInitialFocus(viewEl);
        applyTransform();
        svg.classList.remove('has-selection');
        hideTooltip();
        applyFilters();
    }

    // Beginpositie wanneer het beeld breder is dan het scherm: left, center of right.
    // Per aanzicht via data-focus, anders data-initial-focus op de app, anders center.
    function applyInitialFocus(viewEl) {
        const focus = (viewEl && viewEl.dataset.focus) || kavelApp.dataset.initialFocus || 'center';
        if (focus === 'center') return;
        // layout forceren zodat de wrapper zijn nieuwe maat heeft
        void wrapper.offsetWidth;
        panX = constrainAxis(focus === 'right' ? -1e9 : 1e9, wrapper.clientWidth, mapContainer.clientWidth);
    }

    // --- Side labels (overview) ---
    // Permanent zichtbare labels op elke side-polygon, gepositioneerd op het
    // geometrische middelpunt. Trekken de aandacht via subtiele pulse en maken
    // duidelijk dat de zijdes klikbaar zijn.
    function clearSideLabels() {
        wrapper.querySelectorAll('.side-label').forEach(el => el.remove());
    }

    function renderSideLabels() {
        clearSideLabels();
        const polygons = svg.querySelectorAll('.side-polygon');
        if (!polygons.length) return;

        const wrapperRect = wrapper.getBoundingClientRect();
        if (!wrapperRect.width || !wrapperRect.height) return;

        polygons.forEach(poly => {
            // getBBox geeft coördinaten in SVG-userspace. We mappen die via
            // getBoundingClientRect van de polygon naar pixel-coördinaten van de wrapper.
            const polyRect = poly.getBoundingClientRect();
            if (!polyRect.width || !polyRect.height) return;

            const cx = polyRect.left + polyRect.width / 2 - wrapperRect.left;
            const cy = polyRect.top + polyRect.height / 2 - wrapperRect.top;

            const label = document.createElement('div');
            label.className = 'side-label';
            label.style.left = cx + 'px';
            label.style.top = cy + 'px';

            const mainLabel = poly.dataset.label || 'Bekijk aanzicht';
            const subLabel = poly.dataset.sublabel || 'Bekijk dit aanzicht';

            label.innerHTML = `
                <span class="side-label-text">
                    <span>${mainLabel}</span>
                    <span class="side-label-sub">${subLabel}</span>
                </span>
                <span class="side-label-arrow"><i class="fa fa-arrow-right"></i></span>
            `;

            // Koppel label aan polygon voor hover-sync
            label.addEventListener('click', () => handleSidePolygonClick(poly));
            label.addEventListener('mouseenter', () => poly.classList.add('is-hovering'));
            label.addEventListener('mouseleave', () => poly.classList.remove('is-hovering'));

            wrapper.appendChild(label);

            // Koppel terug: wanneer polygon hovered wordt, label "activeren"
            poly._sideLabel = label;
        });
    }

    // Breedte van de weergavetoggle als css-variabele, zodat de filterknop
    // ernaast blijft staan en er niet onder valt
    const viewToggleWrap = $('viewToggleWrap');
    function updateToggleWidth() {
        if (!viewToggleWrap) return;
        // getBoundingClientRect werkt ook bij position: fixed (offsetParent is dan null)
        const visible = getComputedStyle(viewToggleWrap).display !== 'none';
        const w = visible ? Math.round(viewToggleWrap.getBoundingClientRect().width) : 0;
        kavelApp.style.setProperty('--kk-toggle-width', w + 'px');
    }
    updateToggleWidth();
    window.addEventListener('resize', updateToggleWidth);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(updateToggleWidth);

    // Herpositioneer labels bij resize (ze staan in pixels, dus moeten mee)
    if (typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => {
            if (isOverviewView()) requestAnimationFrame(() => renderSideLabels());
            // Na een resize kan het beeld anders overlopen: pan opnieuw begrenzen
            constrainPan(); applyTransform();
        });
        ro.observe(wrapper);
    } else {
        window.addEventListener('resize', () => {
            if (isOverviewView()) requestAnimationFrame(() => renderSideLabels());
            constrainPan(); applyTransform();
        });
    }

    // --- Filter matching ---
    function kavelMatchesFilters(k) {
        if (activeStatusFilter && k.status !== activeStatusFilter) return false;
        if (activeTypeFilter && k.naam.toLowerCase() !== activeTypeFilter) return false;
        if (activeModelFilter && k.typewoning !== activeModelFilter) return false;
        if (activeBedroomsFilter && k.aantalKamers.replace(/[^\d]/g, '') !== activeBedroomsFilter) return false;
        if (fc.showPr && k.prijsNum > 0 && (k.prijsNum < priceRange[0] || k.prijsNum > priceRange[1])) return false;
        if (fc.showM2 && k.woonoppervlakteNum > 0 && (k.woonoppervlakteNum < m2Range[0] || k.woonoppervlakteNum > m2Range[1])) return false;
        if (fc.showPc && k.perceeloppervlakteNum > 0 && (k.perceeloppervlakteNum < pcRange[0] || k.perceeloppervlakteNum > pcRange[1])) return false;
        return true;
    }

    // --- Filters toepassen ---
    function applyFilters() {
        let ac = [activeStatusFilter, activeTypeFilter, activeModelFilter, activeBedroomsFilter].filter(Boolean).length;
        if (fc.showPr && (priceRange[0] > priceMin || priceRange[1] < priceMax)) ac++;
        if (fc.showM2 && (m2Range[0] > m2Min || m2Range[1] < m2Max)) ac++;
        if (fc.showPc && (pcRange[0] > pcMin || pcRange[1] < pcMax)) ac++;
        mobileFilterBadge.textContent = ac || ''; mobileFilterBadge.dataset.count = ac;

        let mc = [activeModelFilter, activeBedroomsFilter].filter(Boolean).length;
        if (fc.showM2 && (m2Range[0] > m2Min || m2Range[1] < m2Max)) mc++;
        if (fc.showPc && (pcRange[0] > pcMin || pcRange[1] < pcMax)) mc++;
        moreFiltersBadge.textContent = mc || ''; moreFiltersBadge.dataset.count = mc;

        // Op overview-view: geen filter toepassen op SVG (dat zijn side-polygons)
        const onOverview = isOverviewView();

        let visibleCount = 0;
        if (!onOverview) {
            svg.querySelectorAll('.hover-area').forEach(e => {
                const km = e.dataset.aantalKamers || e.dataset.aantalSlaapkamers || '';
                const k = {
                    status: statusToKey(e.dataset.status), naam: e.dataset.naam || '',
                    typewoning: e.dataset.typewoning || '', aantalKamers: km,
                    prijsNum: parsePrice(e.dataset.prijs),
                    woonoppervlakteNum: parseM2(e.dataset.woonoppervlakte),
                    perceeloppervlakteNum: parseM2(e.dataset.perceeloppervlakte)
                };
                const match = kavelMatchesFilters(k);
                e.classList.toggle('is-dimmed', !match);
                if (match) visibleCount++;
            });
        }

        let plCount = 0;
        pricelistBody.querySelectorAll('.pl-row').forEach(row => {
            const k = allKavels.find(x => x.id === row.dataset.id);
            if (k) { const m = kavelMatchesFilters(k); row.classList.toggle('is-dimmed', !m); if (m) plCount++; }
        });

        pricelistEmpty.style.display = plCount === 0 ? 'block' : 'none';

        // Counter: op overview tonen we het totaal aantal woningen (filtering telt alleen op lijst)
        let cnt;
        if (onOverview) {
            cnt = activeView === 'list' ? plCount : allKavels.length;
        } else {
            cnt = activeView === 'map' ? visibleCount : plCount;
        }
        resultsCounter.innerHTML = mobileResultsCounter.innerHTML = `<strong>${cnt}</strong> ${cnt === 1 ? 'woning' : 'woningen'}`;

        if (pinnedId) { const pe = svg.querySelector(`[data-id="${pinnedId}"]`); if (pe?.classList.contains('is-dimmed')) closePanel(); }
        if (isInitialized) updateUrlParams();
    }

    // --- Prijslijst ---
    function chip(icon, text, title) {
        return `<span class="lot-chip" title="${title}"><i class="fa fa-${icon} me-1"></i>${text}</span>`;
    }

    // Knoppen in het uitklappaneel van de prijslijst. Met data-no-detail op de
    // app vervalt de doorklik naar de detailpagina.
    const noDetail = kavelApp.hasAttribute('data-no-detail');
    function lotActions(k) {
        const out = [];
        if (k.interesse) out.push(`<a class="btn btn-primary-kk" href="${k.interesse}">${k.interesseLabel}</a>`);
        if (k.download)  out.push(`<a class="btn btn-outline-kk" href="${k.download}" target="_blank" rel="noopener">${k.downloadLabel}</a>`);
        if (!noDetail && k.info) out.push(`<a class="btn btn-primary-kk" href="${k.info}">Bekijk meer details <i class="fa fa-arrow-right ms-2"></i></a>`);
        return out.join('');
    }

    function renderPricelist() {
        const plCont = document.querySelector('.pricelist-container');
        if (plCont) plCont.classList.toggle('hide-perceel', !fc.showPc);

        const sorted = [...allKavels].sort((a, b) => {
            const MAP = {
                type: [a.naam+' '+a.typewoning, b.naam+' '+b.typewoning],
                woonoppervlakte: [a.woonoppervlakteNum, b.woonoppervlakteNum],
                perceeloppervlakte: [a.perceeloppervlakteNum, b.perceeloppervlakteNum],
                prijs: [a.prijsNum, b.prijsNum]
            };
            if (sortColumn === 'bouwnummer') return sortDirection === 'asc'
                ? a.bouwnummer.localeCompare(b.bouwnummer, 'nl', { numeric: true })
                : b.bouwnummer.localeCompare(a.bouwnummer, 'nl', { numeric: true });
            const [vA, vB] = MAP[sortColumn] || [a.bouwnummer, b.bouwnummer];
            if (typeof vA === 'string') return sortDirection === 'asc' ? vA.localeCompare(vB) : vB.localeCompare(vA);
            return sortDirection === 'asc' ? vA - vB : vB - vA;
        });

        pricelistBody.innerHTML = sorted.map(k => {
            const wl = k.woonlastenUrl ? `<div class="lot-meta"><i class="fa fa-calculator me-2"></i><a href="${k.woonlastenUrl}" target="_blank">Wat zijn mijn woonlasten?</a></div>` : '';
            const sl = situatieToLabels(k.situatie);
            const chips = [
                k.woonoppervlakte    ? chip('ruler-combined', k.woonoppervlakte, k.woonoppervlakte + ' woonoppervlakte') : '',
                k.perceeloppervlakte ? chip('vector-square', k.perceeloppervlakte + ' perceel', k.perceeloppervlakte + ' perceeloppervlakte') : '',
                k.volume             ? chip('cube', k.volume + ' m\u00B3', k.volume + ' m\u00B3 inhoud') : '',
                k.aantalKamers       ? chip('bed', k.aantalKamers + ' slpk', k.aantalKamers + ' slaapkamers') : '',
                k.kamersTotaal       ? chip('door-open', k.kamersTotaal + ' kamers', k.kamersTotaal + ' kamers totaal') : '',
                k.buitenruimte && parseFloat(k.buitenruimte) !== 0 ? chip('sun', k.buitenruimte + ' m\u00B2', k.buitenruimte + ' m\u00B2 buitenruimte') : '',
                k.parkeren           ? chip('square-parking', k.parkeren, k.parkeren) : '',
                k.ligging            ? chip('compass', k.ligging, 'Ligging: ' + k.ligging) : '',
                sl.length            ? chip('location-dot', sl.join(' \u00B7 '), 'Situatie') : ''
            ].join('');
            return `<div class="pl-row" data-id="${k.id}">
                <div class="pl-row-header"><div class="pl-grid">
                    <div>${k.bouwnummer}</div>
                    <div>${k.naam}${k.typewoning ? ' | ' + k.typewoning : ''}</div>
                    <div class="pl-col-woonopp">${k.woonoppervlakte}</div>
                    <div class="pl-col-perceel">${k.perceeloppervlakte || '-'}</div>
                    <div>${k.prijs}</div>
                    <div class="pl-status"><span class="pl-status-dot status-${k.status}"></span><span>${statusToLabel(k.status)}</span></div>
                    <div class="pl-col-arrow"><i class="fa fa-chevron-right"></i></div>
                </div></div>
                <div class="pl-row-panel"><div class="lot-panel status-${k.status}"><div class="lot-panel-inner">
                    <div class="lot-media"><img src="${k.afbeelding}" alt="${k.naam} ${k.bouwnummer}" loading="lazy"></div>
                    <div class="lot-body">
                        <div class="lot-head">
                            <div><div class="lot-number">${lotLabel(k.bouwnummer)}</div><h3 class="lot-title">${k.naam}${k.typewoning ? ' | ' + k.typewoning : ''}</h3></div>
                            <div class="lot-price">${k.prijs}</div>
                        </div>
                        <div class="lot-chips">${chips}</div>
                        <div class="lot-actions">${lotActions(k)}</div>
                        ${wl}
                    </div>
                </div></div></div>
            </div>`;
        }).join('');

        pricelistBody.querySelectorAll('.pl-row-header').forEach(h => {
            h.addEventListener('click', () => {
                const r = h.closest('.pl-row'), expanded = r.classList.contains('is-expanded');
                pricelistBody.querySelectorAll('.pl-row.is-expanded').forEach(x => x.classList.remove('is-expanded'));
                if (!expanded) r.classList.add('is-expanded');
            });
        });
        applyFilters();
    }

    // Sort
    document.querySelectorAll('.pricelist-header .pl-col[data-sort]').forEach(col => {
        col.addEventListener('click', () => {
            const ns = col.dataset.sort;
            sortDirection = sortColumn === ns ? (sortDirection === 'asc' ? 'desc' : 'asc') : 'asc';
            sortColumn = ns;
            document.querySelectorAll('.pricelist-header .pl-col').forEach(c => {
                c.classList.remove('sort-active');
                const i = c.querySelector('.sort-icon'); if (i) i.className = 'fa fa-sort sort-icon';
            });
            col.classList.add('sort-active');
            const ic = col.querySelector('.sort-icon'); if (ic) ic.className = `fa fa-sort-${sortDirection === 'asc' ? 'up' : 'down'} sort-icon`;
            renderPricelist();
        });
    });

    // View toggle
    function setActiveView(v) {
        activeView = v;
        viewMapBtn.classList.toggle('active', v === 'map'); viewListBtn.classList.toggle('active', v === 'list');
        viewMapBtnMobile.classList.toggle('active', v === 'map'); viewListBtnMobile.classList.toggle('active', v === 'list');
        mapContainer.style.display = v === 'map' ? '' : 'none';
        pricelistContainer.classList.toggle('is-active', v === 'list');
        applyFilters();
    }
    viewMapBtn.addEventListener('click', () => setActiveView('map'));
    viewListBtn.addEventListener('click', () => setActiveView('list'));
    viewMapBtnMobile.addEventListener('click', () => setActiveView('map'));
    viewListBtnMobile.addEventListener('click', () => setActiveView('list'));

    // Filter events
    filterStatus.addEventListener('change',  () => { activeStatusFilter  = filterStatus.value;  applyFilters(); });
    filterType.addEventListener('change',    () => { activeTypeFilter    = filterType.value.toLowerCase();   applyFilters(); });
    filterModel.addEventListener('change',   () => { activeModelFilter   = filterModel.value;   if (filterModelDropdown)    filterModelDropdown.value    = activeModelFilter;   applyFilters(); });
    filterBedrooms.addEventListener('change',() => { activeBedroomsFilter= filterBedrooms.value;if (filterBedroomsDropdown) filterBedroomsDropdown.value = activeBedroomsFilter;applyFilters(); });
    if (filterModelDropdown)    filterModelDropdown.addEventListener('change',    () => { activeModelFilter    = filterModelDropdown.value;    filterModel.value    = activeModelFilter;    applyFilters(); });
    if (filterBedroomsDropdown) filterBedroomsDropdown.addEventListener('change', () => { activeBedroomsFilter = filterBedroomsDropdown.value; filterBedrooms.value = activeBedroomsFilter; applyFilters(); });
    resetBtn.addEventListener('click', resetAllFilters);

    function resetAllFilters() {
        activeStatusFilter = activeTypeFilter = activeModelFilter = activeBedroomsFilter = '';
        [filterStatus, filterType, filterModel, filterBedrooms,
         filterStatusMobile, filterTypeMobile, filterModelMobile, filterBedroomsMobile,
         filterModelDropdown, filterBedroomsDropdown].forEach(s => { if (s) s.value = ''; });
        priceRange = [priceMin, priceMax]; m2Range = [m2Min, m2Max]; pcRange = [pcMin, pcMax];
        [priceSlider, priceSliderMobile].forEach(s => s?.set([priceMin, priceMax]));
        [m2Slider, m2SliderMobile, m2SliderDD].forEach(s => s?.set([m2Min, m2Max]));
        [pcSlider, pcSliderMobile, pcSliderDD].forEach(s => s?.set([pcMin, pcMax]));
        scale = 1; panX = 0; panY = 0; applyTransform(); applyFilters();
    }

    // Meer filters dropdown
    function openMoreFilters() {
        moreFiltersDropdown.classList.add('is-open'); moreFiltersBtn.classList.add('is-active');
        if (filterModelDropdown)    filterModelDropdown.value    = activeModelFilter;
        if (filterBedroomsDropdown) filterBedroomsDropdown.value = activeBedroomsFilter;
        if (m2SliderDD) m2SliderDD.set(m2Range);
        if (pcSliderDD) pcSliderDD.set(pcRange);
    }
    function closeMoreFilters() { moreFiltersDropdown.classList.remove('is-open'); moreFiltersBtn.classList.remove('is-active'); }
    moreFiltersBtn.addEventListener('click', e => { e.stopPropagation(); moreFiltersDropdown.classList.contains('is-open') ? closeMoreFilters() : openMoreFilters(); });
    document.addEventListener('click', e => { if (!moreFiltersDropdown.contains(e.target) && !moreFiltersBtn.contains(e.target)) closeMoreFilters(); });

    // Mobiele filter drawer
    // activeTypeFilter is lowercase voor het vergelijken; de select heeft de
    // originele schrijfwijze, dus die opzoeken voor de preselectie
    function typeSelectValue() {
        return kavelData.types.find(t => t.toLowerCase() === activeTypeFilter) || '';
    }
    function openFilterDrawer() {
        filterDrawer.classList.add('is-open'); filterDrawerOverlay.classList.add('is-visible'); document.body.style.overflow = 'hidden';
        filterStatusMobile.value = activeStatusFilter; filterTypeMobile.value = typeSelectValue();
        filterModelMobile.value  = activeModelFilter;  filterBedroomsMobile.value = activeBedroomsFilter;
        if (priceSliderMobile) priceSliderMobile.set(priceRange);
        if (m2SliderMobile)    m2SliderMobile.set(m2Range);
        if (pcSliderMobile)    pcSliderMobile.set(pcRange);
    }
    function closeFilterDrawer() { filterDrawer.classList.remove('is-open'); filterDrawerOverlay.classList.remove('is-visible'); document.body.style.overflow = ''; }
    mobileFilterBtn.addEventListener('click', openFilterDrawer);
    filterDrawerClose.addEventListener('click', closeFilterDrawer);
    filterDrawerOverlay.addEventListener('click', closeFilterDrawer);
    filterDrawerReset.addEventListener('click', () => { resetAllFilters(); closeFilterDrawer(); });
    filterDrawerApply.addEventListener('click', () => {
        activeStatusFilter   = filterStatusMobile.value;
        activeTypeFilter     = filterTypeMobile.value.toLowerCase();  // lowercase voor filtering
        activeModelFilter    = filterModelMobile.value;
        activeBedroomsFilter = filterBedroomsMobile.value;
        if (priceSliderMobile) priceRange = priceSliderMobile.get();
        if (m2SliderMobile)    m2Range    = m2SliderMobile.get();
        if (pcSliderMobile)    pcRange    = pcSliderMobile.get();
        filterStatus.value = activeStatusFilter;
        filterType.value   = filterTypeMobile.value;  // originele waarde voor select
        filterModel.value  = activeModelFilter;
        filterBedrooms.value = activeBedroomsFilter;
        if (priceSlider) priceSlider.set(priceRange);
        if (m2Slider)    m2Slider.set(m2Range);
        if (pcSlider)    pcSlider.set(pcRange);
        applyFilters(); closeFilterDrawer();
    });

    // View navigatie - skip overview bij prev/next (navigatie tussen detail-views)
    function updateViewButtons() {
        // Single = geen navigatie mogelijk
        const singleDetail = detailViewIndices.length <= 1;
        const onOverview = isOverviewView();

        // Op overview: geen prev/next pijlen of select
        if (onOverview) {
            viewPrev.style.display = viewNext.style.display = viewSelect.style.display = 'none';
            updateViewSeg();
            return;
        }

        viewPrev.style.display = viewNext.style.display = viewSelect.style.display = singleDetail ? 'none' : '';

        // Bepaal positie in detail-views voor prev/next disabled state
        const detailPos = detailViewIndices.indexOf(currentViewIndex);
        viewPrev.disabled = detailPos <= 0;
        viewNext.disabled = detailPos >= detailViewIndices.length - 1;
        updateViewSeg();
    }

    // Helper: switch naar een specifieke view index en update URL
    function switchToView(idx) {
        if (idx < 0 || idx >= views.length) return;
        // Panel sluiten bij view-wissel
        if (isOpen) closePanel();
        currentViewIndex = idx;
        viewSelect.value = currentViewIndex;
        renderView(currentViewIndex);
        updateViewButtons();
        if (isInitialized) updateUrlParams();
    }

    // Navigeer naar volgende/vorige detail-view (skip overview)
    function navigateDetailView(direction) {
        const detailPos = detailViewIndices.indexOf(currentViewIndex);
        if (detailPos < 0) return; // we zitten niet op een detail-view
        const newPos = detailPos + direction;
        if (newPos < 0 || newPos >= detailViewIndices.length) return;
        switchToView(detailViewIndices[newPos]);
    }

    viewSelect.addEventListener('change', () => { switchToView(parseInt(viewSelect.value)); });

    // Bij precies twee detail-aanzichten: segmented toggle in plaats van dropdown
    let viewSeg = null;
    if (detailViewIndices.length === 2) {
        viewSeg = document.createElement('div');
        viewSeg.className = 'view-seg';
        detailViewIndices.forEach(idx => {
            const b = document.createElement('button');
            b.type = 'button'; b.textContent = views[idx].label; b.dataset.view = idx;
            b.addEventListener('click', () => switchToView(idx));
            viewSeg.appendChild(b);
        });
        viewSelect.parentNode.insertBefore(viewSeg, viewSelect);
        viewSelect.classList.add('view-select-hidden');
    }
    function updateViewSeg() {
        if (!viewSeg) return;
        viewSeg.style.display = isOverviewView() ? 'none' : '';
        viewSeg.querySelectorAll('button').forEach(b => b.classList.toggle('active', parseInt(b.dataset.view) === currentViewIndex));
    }
    viewPrev.addEventListener('click', () => navigateDetailView(-1));
    viewNext.addEventListener('click', () => navigateDetailView(1));

    // Terug-naar-overzicht knop
    if (btnBackOverview) {
        btnBackOverview.addEventListener('click', () => {
            if (hasOverview) switchToView(overviewIndex);
        });
    }

    // --- Tooltip (detail-views) ---
    function showTooltip(el, cx, cy) {
        if (isOpen) return;
        const d = el.dataset;
        const r = wrapper.getBoundingClientRect();
        let x = cx - r.left + 15, y = cy - r.top + 15;
        if (x + 280 > r.width - 20)  x = cx - r.left - 295;
        if (y + 240 > r.height - 20) y = cy - r.top - 255;
        tooltip.style.left = Math.max(10, x) + 'px';
        tooltip.style.top  = Math.max(10, y) + 'px';

        tooltip.querySelector('.tooltip-image').src = d.afbeelding || '';
        const bn = tooltip.querySelector('.tooltip-bouwnummer');
        if (bn) { bn.textContent = lotLabel(d.bouwnummer); bn.style.display = d.bouwnummer ? 'block' : 'none'; }
        tooltip.querySelector('.tooltip-title').textContent = d.naam || d.typewoning || '';
        tooltip.querySelector('.tooltip-badge').textContent = statusToLabel(d.status);
        tooltip.querySelector('.tooltip-badge').className = 'tooltip-badge ' + statusToTooltipBadge(d.status);
        tooltip.querySelector('.tooltip-price').textContent = d.prijs || '';

        const km = d.aantalKamers || d.aantalSlaapkamers || '';
        const ts = (icon, text) => `<span class="tooltip-spec"><i class="fa fa-${icon}"></i> ${text}</span>`;
        tooltip.querySelector('.tooltip-specs').innerHTML = [
            d.woonoppervlakte    && parseFloat(d.woonoppervlakte)    !== 0 ? ts('ruler-combined', d.woonoppervlakte + ' m\u00B2') : '',
            d.perceeloppervlakte && parseFloat(d.perceeloppervlakte) !== 0 ? ts('vector-square', d.perceeloppervlakte + ' m\u00B2') : '',
            km && parseInt(km) > 0 ? ts('bed', km + ' slpk') : ''
        ].join('');
        tooltip.style.display = 'block';
    }

    // --- Tooltip (overview zijde) ---
    function showOverviewTooltip(el, cx, cy) {
        if (!tooltipOverview) return;
        const d = el.dataset;
        const r = wrapper.getBoundingClientRect();
        // Maak eerst zichtbaar voor dimensies
        tooltipOverview.style.display = 'block';
        tooltipOverview.style.left = '-9999px';
        tooltipOverview.querySelector('.tooltip-overview-title').textContent = d.label || '';
        tooltipOverview.querySelector('.tooltip-overview-sub').textContent = d.sublabel || '';

        // Positioneer naast de cursor, binnen wrapper
        const tw = tooltipOverview.offsetWidth || 200;
        const th = tooltipOverview.offsetHeight || 50;
        let x = cx - r.left + 15, y = cy - r.top + 15;
        if (x + tw > r.width - 10)  x = cx - r.left - tw - 15;
        if (y + th > r.height - 10) y = cy - r.top - th - 15;
        tooltipOverview.style.left = Math.max(10, x) + 'px';
        tooltipOverview.style.top  = Math.max(10, y) + 'px';
    }

    function hideTooltip() {
        tooltip.style.display = 'none';
        if (tooltipOverview) tooltipOverview.style.display = 'none';
    }

    function getHoverAreaAtPoint(x, y) {
        return document.elementsFromPoint(x, y).find(e => e.classList?.contains('hover-area'));
    }
    function getSidePolygonAtPoint(x, y) {
        return document.elementsFromPoint(x, y).find(e => e.classList?.contains('side-polygon'));
    }

    let currentHoverEl = null;
    svg.addEventListener('mousemove', e => {
        if (isOpen) return;

        // Overview modus: hover op side-polygons
        if (isOverviewView()) {
            const hov = getSidePolygonAtPoint(e.clientX, e.clientY);
            if (hov !== currentHoverEl) {
                if (currentHoverEl) {
                    currentHoverEl.classList.remove('is-hovering');
                    if (currentHoverEl._sideLabel) currentHoverEl._sideLabel.classList.remove('is-active');
                }
                currentHoverEl = hov;
                if (hov) {
                    hov.classList.add('is-hovering');
                    svg.appendChild(hov);
                    // Sync hover state naar bijbehorend label
                    if (hov._sideLabel) hov._sideLabel.classList.add('is-active');
                }
            }
            // Overview tooltip wordt niet meer gebruikt: het permanente label
            // toont al de info. Zorg dat 'm verborgen is.
            hideTooltip();
            return;
        }

        // Detail-view: normale hover-area logica
        const hov = getHoverAreaAtPoint(e.clientX, e.clientY);
        if (hov !== currentHoverEl) {
            if (currentHoverEl) currentHoverEl.classList.remove('is-hovering');
            currentHoverEl = hov;
            if (hov && !hov.classList.contains('is-dimmed')) { hov.classList.add('is-hovering'); svg.appendChild(hov); }
        }
        if (!hov || hov.classList.contains('is-dimmed')) { hideTooltip(); return; }
        showTooltip(hov, e.clientX, e.clientY);
    });
    svg.addEventListener('mouseleave', () => {
        hideTooltip();
        if (currentHoverEl) {
            currentHoverEl.classList.remove('is-hovering');
            if (currentHoverEl._sideLabel) currentHoverEl._sideLabel.classList.remove('is-active');
            currentHoverEl = null;
        }
    });

    // --- Details panel ---
    function openPanel(el) {
        const d = el.dataset;
        svg.querySelectorAll('.hover-area').forEach(p => p.classList.remove('is-selected', 'is-hovering'));
        el.classList.add('is-selected'); svg.classList.add('has-selection');

        setText('detailsType', d.naam || '');
        const statusEl = $('detailsStatus');
        statusEl.textContent = statusToLabel(d.status); statusEl.className = 'badge ' + statusToBadgeClass(d.status);
        $('detailsImage').src = d.afbeelding || '';
        setText('detailsTitle', d.bouwnummer ? lotLabel(d.bouwnummer) : d.naam || '');
        // Optionele ondertitel met het woningtype (alleen als het element in de html staat)
        setText('detailsSubtitle', d.naam || '');
        setText('detailsPrice', d.prijs || '');

        // Spec-tags
        const m2Val = d.woonoppervlakte && parseFloat(d.woonoppervlakte) !== 0 ? d.woonoppervlakte + ' m\u00B2' : '-';
        setText('detailsM2', m2Val);
        const m2Tag = $('detailsM2')?.closest('.spec-tag');
        if (m2Tag) { m2Tag.title = m2Val !== '-' ? m2Val + ' woonoppervlakte' : ''; m2Tag.style.display = m2Val !== '-' ? '' : 'none'; }

        const km = d.aantalKamers || d.aantalSlaapkamers || '';
        const slpk = km.replace(/[^\d]/g, '') || '-';
        setText('detailsSlaapkamers', slpk);
        const slpkTag = $('detailsSlaapkamers')?.closest('.spec-tag');
        if (slpkTag) {
            slpkTag.title = slpk !== '-' ? slpk + ' slaapkamer' + (slpk !== '1' ? 's' : '') : '';
            // geen slaapkamers bekend of 0 (losse kavel): tag verbergen
            slpkTag.style.display = slpk !== '-' && parseInt(slpk) > 0 ? '' : 'none';
        }

        const pcVal = d.perceeloppervlakte && parseFloat(d.perceeloppervlakte) !== 0 ? d.perceeloppervlakte + ' m\u00B2' : '-';
        setText('detailsPerceel2', pcVal !== '-' ? pcVal : '');
        showTag('detailsPerceelTag', pcVal !== '-');
        // Perceel staat al als spec-tag, niet ook in kenmerken tabel tonen
        showDd('detailsPerceel', false);

        const kt = d.kamersTotaal && parseInt(d.kamersTotaal) > 0 ? d.kamersTotaal : '';
        // Kamers totaal: alleen in kenmerken tabel, niet als spec-tag
        showTag('detailsKamersTotaalTag', false);

        const pl = parkerenLabel(d.parkeren, d.parkerenAantal);
        // Parkeren: alleen in kenmerken tabel, niet als spec-tag
        showTag('detailsParkerenTag', false);
        setText('detailsParkeren', pl || '-'); showDd('detailsParkeren', !!pl);

        // Kenmerken dl
        setText('detailsBouwtype', d.naam || '');
        setText('detailsKamersTotaal2', kt); showDd('detailsKamersTotaal2', !!kt);
        const volShow = d.volume && parseFloat(d.volume) > 0;
        setText('detailsVolume', volShow ? d.volume + ' m\u00B3' : '-'); showDd('detailsVolume', volShow);
        setText('detailsVerdieping', d.verdieping ? (d.verdieping === '0' ? 'Begane grond' : d.verdieping + 'e') : '-');
        showDd('detailsVerdieping', !!d.verdieping);
        const bShow = d.buitenruimte && parseFloat(d.buitenruimte) !== 0;
        setText('detailsBuitenruimte', bShow ? d.buitenruimte + ' m\u00B2' : '-'); showDd('detailsBuitenruimte', bShow);
        setText('detailsLigging', d.ligging || '-'); showDd('detailsLigging', !!d.ligging);
        const sl = situatieToLabels(d.situatie);
        setText('detailsSituatie', sl.join(' \u00B7 ') || '-'); showDd('detailsSituatie', sl.length > 0);

        // Doorklik naar detailpagina (alleen als de knoppen in de html staan)
        ['detailsInschrijven', 'detailsInfo', 'detailsInfoMobile'].forEach(id => {
            const el = $(id); if (el) el.href = d.info || '#';
        });

        // Optioneel: downloadlink en interesse-link (per polygon via data-attributen)
        const setLink = (id, href, label) => {
            const el = $(id); if (!el) return;
            if (href) {
                el.href = href;
                const lbl = el.querySelector('.link-label'); if (lbl && label) lbl.textContent = label;
                el.style.display = '';
            } else {
                el.style.display = 'none';
            }
        };
        setLink('detailsDownload', d.download, d.downloadLabel);
        setLink('detailsInteresse', d.interesse, d.interesseLabel);
        setLink('detailsInteresseMobile', d.interesse, d.interesseLabel);
        setLink('detailsDownloadMobile', d.download, d.downloadLabel);

        panel.classList.add('is-open'); isOpen = true; pinnedId = d.id; hideTooltip();
        applyTransform();
    }

    function closePanel() {
        panel.classList.remove('is-open'); isOpen = false; pinnedId = null;
        svg.querySelectorAll('.hover-area.is-selected').forEach(p => p.classList.remove('is-selected'));
        svg.classList.remove('has-selection');
        applyTransform();
    }

    // Klik op side-polygon (overview) → navigeer naar target-view
    function handleSidePolygonClick(el) {
        const targetId = el.dataset.targetViewId;
        if (!targetId) { console.warn('Kavelkiezer: side-polygon heeft geen data-target-view-id'); return; }
        const targetIdx = views.findIndex(v => v.id === targetId);
        if (targetIdx < 0) { console.warn('Kavelkiezer: target view niet gevonden:', targetId); return; }
        switchToView(targetIdx);
    }

    svg.addEventListener('click', e => {
        // Overview modus: klik op zijde → naar target-view
        if (isOverviewView()) {
            const side = getSidePolygonAtPoint(e.clientX, e.clientY);
            if (side) handleSidePolygonClick(side);
            return;
        }

        // Detail-view: bestaande woning-click logica
        const hov = getHoverAreaAtPoint(e.clientX, e.clientY);
        if (!hov || hov.classList.contains('is-dimmed')) return;
        hov.classList.contains('is-selected') ? closePanel() : openPanel(hov);
    });

    svg.addEventListener('keydown', e => {
        if (e.key !== 'Enter' && e.key !== ' ') return;

        // Overview modus: toetsenbord-navigatie op side-polygons
        if (isOverviewView()) {
            const side = e.target.closest('.side-polygon');
            if (side) { e.preventDefault(); handleSidePolygonClick(side); }
            return;
        }

        const hov = e.target.closest('.hover-area');
        if (!hov || hov.classList.contains('is-dimmed')) return;
        e.preventDefault(); hov.classList.contains('is-selected') ? closePanel() : openPanel(hov);
    });
    $('detailsClose').addEventListener('click', closePanel);
    overlayBg.addEventListener('click', closePanel);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closePanel(); });

    // --- Zoom & pan ---
    // Slepen kan wanneer er ingezoomd is, of wanneer het beeld (op zoomniveau 1)
    // groter is dan de container, zoals bij het schermvullende beeld.
    function canPan() {
        if (isOpen) return false;
        return scale > 1
            || wrapper.clientWidth  > mapContainer.clientWidth  + 1
            || wrapper.clientHeight > mapContainer.clientHeight + 1;
    }
    // Op zoomniveau 1 alleen horizontaal slepen: verticale vegen gaan naar de
    // pagina (touch-action: pan-y via .draggable). Ingezoomd in beide richtingen.
    function isHorizontalOnly() { return scale <= 1; }
    function applyTransform() {
        const t = `matrix(${scale},0,0,${scale},${panX},${panY})`;
        bgImg.style.transform = svg.style.transform = t;
        wrapper.classList.toggle('draggable', canPan());
        wrapper.classList.toggle('draggable-zoomed', canPan() && !isHorizontalOnly());
    }
    // Het beeld moet de container altijd blijven bedekken. De wrapper staat
    // gecentreerd in de container, dus de offset is negatief als hij groter is.
    function constrainAxis(pan, size, cont) {
        const scaled = size * scale;
        if (scaled <= cont) return Math.min(0, Math.max(size - scaled, pan));
        const off = (cont - size) / 2;
        return Math.min(-off, Math.max(cont - off - scaled, pan));
    }
    function constrainPan() {
        panX = constrainAxis(panX, wrapper.clientWidth,  mapContainer.clientWidth);
        panY = constrainAxis(panY, wrapper.clientHeight, mapContainer.clientHeight);
    }
    function zoomAt(cx, cy, f) {
        if (isOpen) return; hideTooltip(); stopMomentum();
        const r = wrapper.getBoundingClientRect();
        const px = (cx - r.left - panX) / scale, py = (cy - r.top - panY) / scale;
        scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale * f));
        panX = cx - r.left - px * scale; panY = cy - r.top - py * scale;
        constrainPan(); applyTransform();
    }
    document.querySelector('.zoom-controls').addEventListener('click', e => {
        const btn = e.target.closest('button'); if (!btn || btn.id === 'toggleOverlay') return;
        const r = wrapper.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2;
        if (btn.dataset.zoom === 'in')    zoomAt(cx, cy, 1.3);
        if (btn.dataset.zoom === 'out')   zoomAt(cx, cy, 1 / 1.3);
        if (btn.dataset.zoom === 'reset') { stopMomentum(); scale = 1; panX = 0; panY = 0; applyTransform(); }
    });
    wrapper.addEventListener('wheel', e => {
        if (isOpen || !e.ctrlKey || isOverviewView()) return;
        e.preventDefault(); zoomAt(e.clientX, e.clientY, e.deltaY < 0 ? 1.1 : 1 / 1.1);
    }, { passive: false });
    // --- Slepen met momentum ---
    // Na loslaten rolt het beeld door met wrijving en stuitert kort terug op de
    // randen, zoals bij een swipe op een telefoon.
    const FRICTION = 0.94,     // per frame, lager = sneller uitrollen
          BOUNCE   = 0.35,     // deel van de snelheid dat terugkaatst op de rand
          MIN_VEL  = 0.15;     // px per frame, daaronder stoppen
    let momentumRaf = null;

    function stopMomentum() {
        if (momentumRaf) { cancelAnimationFrame(momentumRaf); momentumRaf = null; }
    }

    function startMomentum(vx, vy) {
        stopMomentum();
        if (Math.abs(vx) < MIN_VEL && Math.abs(vy) < MIN_VEL) return;
        const step = () => {
            const beforeX = panX + vx, beforeY = panY + vy;
            panX = beforeX; panY = beforeY;
            constrainPan();
            // Rand geraakt: snelheid omkeren en dempen
            if (panX !== beforeX) vx = -vx * BOUNCE;
            if (panY !== beforeY) vy = -vy * BOUNCE;
            vx *= FRICTION; vy *= FRICTION;
            applyTransform();
            if (Math.abs(vx) < MIN_VEL && Math.abs(vy) < MIN_VEL) { momentumRaf = null; return; }
            momentumRaf = requestAnimationFrame(step);
        };
        momentumRaf = requestAnimationFrame(step);
    }

    wrapper.addEventListener('pointerdown', e => {
        if (!canPan() || e.target.closest('button, select, a') || isOverviewView()) return;
        // Geen preventDefault op zoomniveau 1: de browser mag een verticale veeg
        // omzetten in pagina-scroll (touch-action: pan-y). Ingezoomd wel blokkeren.
        const horizontalOnly = isHorizontalOnly();
        if (!horizontalOnly) e.preventDefault();
        stopMomentum();
        hideTooltip(); wrapper.classList.add('panning');
        let lx = e.clientX, ly = e.clientY, lt = performance.now();
        let vx = 0, vy = 0;
        const onMove = ev => {
            const now = performance.now(), dt = Math.max(1, now - lt);
            const dx = ev.clientX - lx, dy = horizontalOnly ? 0 : ev.clientY - ly;
            // snelheid in px per frame (16ms), gladgestreken over de laatste bewegingen
            vx = vx * 0.4 + (dx / dt * 16) * 0.6;
            vy = vy * 0.4 + (dy / dt * 16) * 0.6;
            panX += dx; panY += dy; lx = ev.clientX; ly = ev.clientY; lt = now;
            constrainPan(); applyTransform();
        };
        const onUp = ev => {
            wrapper.classList.remove('panning');
            window.removeEventListener('pointermove', onMove);
            window.removeEventListener('pointerup', onUp);
            window.removeEventListener('pointercancel', onUp);
            // pointercancel: de browser heeft de veeg overgenomen (pagina scrolt), niet doorrollen
            if (ev.type === 'pointercancel') return;
            if (performance.now() - lt < 80) startMomentum(vx, horizontalOnly ? 0 : vy);
        };
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
    });
    $('toggleOverlay').addEventListener('click', function() {
        const h = svg.style.display === 'none'; svg.style.display = h ? '' : 'none';
        this.querySelector('i').className = h ? 'fa fa-eye' : 'fa fa-eye-slash';
    });

    // --- URL params ---
    function updateUrlParams() {
        const p = new URLSearchParams();
        if (activeStatusFilter)  p.set('status', activeStatusFilter);
        if (activeTypeFilter)    p.set('type', activeTypeFilter);
        if (activeModelFilter)   p.set('model', activeModelFilter);
        if (activeBedroomsFilter)p.set('slaapkamers', activeBedroomsFilter);
        if (fc.showPr && (priceRange[0] > priceMin || priceRange[1] < priceMax)) p.set('prijs',   priceRange.join('-'));
        if (fc.showM2 && (m2Range[0] > m2Min || m2Range[1] < m2Max))            p.set('woonopp', m2Range.join('-'));
        if (fc.showPc && (pcRange[0] > pcMin || pcRange[1] < pcMax))            p.set('perceel', pcRange.join('-'));
        if (activeView === 'list') p.set('weergave', 'lijst');
        // Zijde toevoegen aan URL (alleen als niet de eerste view)
        // NB: overview niet als zijde toevoegen — dat is de default landing
        if (currentViewIndex > 0 && views[currentViewIndex] && views[currentViewIndex].type !== 'overview') {
            p.set('zijde', views[currentViewIndex].id);
        }
        history.replaceState({}, '', p.toString() ? location.pathname + '?' + p : location.pathname);
    }

    function readUrlParams() {
        const p = new URLSearchParams(location.search);
        const st = p.get('status'); if (st && kavelData.statuses.includes(st)) { activeStatusFilter = st; filterStatus.value = st; filterStatusMobile.value = st; }
        // Type: zoek originele waarde (met hoofdletters) voor select, maar filter lowercase
        const ty = p.get('type');
        if (ty) {
            const originalType = kavelData.types.find(t => t.toLowerCase() === ty.toLowerCase());
            if (originalType) {
                activeTypeFilter = ty.toLowerCase();
                filterType.value = originalType;
                filterTypeMobile.value = originalType;
            }
        }
        const mo = p.get('model');  if (mo && kavelData.models.includes(mo)) { activeModelFilter = mo; filterModel.value = mo; filterModelMobile.value = mo; }
        const sl = p.get('slaapkamers'); if (sl && kavelData.bedrooms.includes(sl)) { activeBedroomsFilter = sl; filterBedrooms.value = sl; filterBedroomsMobile.value = sl; }
        const setPair = (key, mn, mx, range, sliders) => {
            const v = p.get(key); if (!v?.includes('-')) return;
            const [a, b] = v.split('-').map(Number);
            if (!isNaN(a) && !isNaN(b) && a >= mn && b <= mx) { range[0] = a; range[1] = b; sliders.forEach(s => s?.set([a, b])); }
        };
        setPair('prijs',   priceMin, priceMax, priceRange, [priceSlider, priceSliderMobile]);
        setPair('woonopp', m2Min,    m2Max,    m2Range,    [m2Slider, m2SliderMobile]);
        setPair('perceel', pcMin,    pcMax,    pcRange,    [pcSlider, pcSliderMobile]);
        if (p.get('weergave') === 'lijst') setActiveView('list');

        // Bepaal welke view als landing wordt getoond:
        // 1. Als er een ?zijde= in URL staat → die view (skip overview)
        // 2. Als er filters in URL staan → skip overview, toon eerste detail-view
        // 3. Anders → overview als landing (indien aanwezig), anders eerste detail-view
        const zijde = p.get('zijde');
        const hasActiveFilters = !!(activeStatusFilter || activeTypeFilter || activeModelFilter
            || activeBedroomsFilter || p.get('prijs') || p.get('woonopp') || p.get('perceel'));

        let landingIdx = -1;

        if (zijde) {
            // Specifieke zijde in URL
            const idx = views.findIndex(v => v.id === zijde);
            if (idx >= 0) landingIdx = idx;
        }

        if (landingIdx < 0 && hasActiveFilters) {
            // Filters actief → eerste detail-view (skip overview)
            landingIdx = detailViewIndices[0] !== undefined ? detailViewIndices[0] : 0;
        }

        if (landingIdx < 0) {
            // Standaard landing: overview indien aanwezig, anders eerste view
            landingIdx = hasOverview ? overviewIndex : 0;
        }

        currentViewIndex = landingIdx;
    }

    // Mobiele melding "bekijk op desktop", eenmalig per sessie
    const notice = $('kavelNotice');
    if (notice) {
        const key = 'kk-notice-dismissed';
        let dismissed = false;
        try { dismissed = sessionStorage.getItem(key) === '1'; } catch (e) {}
        if (!dismissed) notice.classList.add('is-visible');
        const closeBtn = notice.querySelector('.kavel-notice-close');
        if (closeBtn) closeBtn.addEventListener('click', () => {
            notice.classList.remove('is-visible');
            try { sessionStorage.setItem(key, '1'); } catch (e) {}
        });
    }

    // Open detail-links in parent als we in een iframe zitten
    document.addEventListener('click', e => {
        const a = e.target.closest('a[href]');
        if (!a) return;
        const href = a.getAttribute('href');
        if (!href || href === '#') return;
        if (window.self !== window.top) {
            e.preventDefault();
            window.top.location.href = href;
        }
    });

    // Init - volgorde is belangrijk:
    // 1. Eerst URL params lezen (incl. zijde + overview-landing logica)
    // 2. Dan view renderen met de juiste index
    // 3. Rest initialiseren
    readUrlParams();
    renderView(currentViewIndex);
    viewSelect.value = currentViewIndex;
    renderPricelist();
    applyFilters();
    updateViewButtons();
    isInitialized = true;
})();